theme.RS = theme.RS || {};
theme.RS.Cart = (function() {
  const selectors = {
    header: '#shopify-section-header',
    cartTrigger: '[data-cart-trigger]',
    cartWrapper: '#cart-ajax__wrapper',
    cartDrawer: '.cart-ajax',
    cartTitle: '.cart-ajax__title',
    cartList: '.cart-ajax__list',
    cartTool: '.cart-ajax__tools',
    mainContent: '#MainContent'
  };
  const CART_VISIBLE_CLASS = 'cart-ajax--visible';
  const HEADER_HEIGHT_EVENT = 'headerHeightChanged';
  let headerElem = document.querySelector(selectors.header);
  let cartTriggerElem = document.querySelector(selectors.cartTrigger);
  let cartWrapperElem = document.querySelector(selectors.cartWrapper);
  let cartDrawerElem = cartWrapperElem?.querySelector(selectors.cartDrawer);
  let cartTitleElem = cartWrapperElem?.querySelector(selectors.cartTitle);
  let cartListElem = cartWrapperElem?.querySelector(selectors.cartList);
  let cartToolElem = cartWrapperElem?.querySelector(selectors.cartTool);
  let mainContentElem = document.querySelector(selectors.mainContent);
  let headerHeight = theme.RS.helpers.calculateTotalHeight(headerElem);
  let windowHeight = window.innerHeight || document.documentElement.clientHeight;
  let windowWidth = window.innerWidth || document.documentElement.clientWidth;
  let ajaxCartObserver = null;
  let headerObserver = null;
  let ajaxContentObserver = null;

  const checkAndAssignHeaderElem = function() {
    if (!headerElem || !document.body.contains(headerElem)) {
      headerElem = document.querySelector(selectors.header);
    }
  };

  const checkAndAssignMainContentElem = function() {
    if (!mainContentElem || !document.body.contains(mainContentElem)) {
      mainContentElem = document.querySelector(selectors.mainContent);
    }
  };

  // The theme code replaces the entire ajax cart content when items are added to cart
  const checkAndAssignCartElements = function() {
    checkAndAssignHeaderElem();
    if (!cartTriggerElem || !document.body.contains(cartTriggerElem)) {
      cartTriggerElem = document.querySelector(selectors.cartTrigger);
    }
    if (!cartWrapperElem || !document.body.contains(cartWrapperElem)) {
      cartWrapperElem = document.querySelector(selectors.cartWrapper);
    }
    if (!cartDrawerElem || !document.body.contains(cartDrawerElem)) {
      cartDrawerElem = cartWrapperElem?.querySelector(selectors.cartDrawer);
    }
    if (!cartTitleElem || !document.body.contains(cartTitleElem)) {
      cartTitleElem = cartWrapperElem?.querySelector(selectors.cartTitle);
    }
    if (!cartListElem || !document.body.contains(cartListElem)) {
      cartListElem = cartWrapperElem?.querySelector(selectors.cartList);
    }
    if (!cartToolElem || !document.body.contains(cartToolElem)) {
      cartToolElem = cartWrapperElem?.querySelector(selectors.cartTool);
    }
  };

  const setCartHeight = function() {
    checkAndAssignCartElements();
    const cartToolHeight = theme.RS.helpers.calculateTotalHeight(cartToolElem);
    const cartTitleHeight = theme.RS.helpers.calculateTotalHeight(cartTitleElem);
    const cartDrawerMaxHeight = theme.RS.helpers.calculateElementToViewportBottom(cartDrawerElem);
    const cartDrawerPadding = 36;
    const cartListMaxHeight = cartDrawerMaxHeight - cartToolHeight - cartTitleHeight - cartDrawerPadding;
    if (cartListElem && cartListMaxHeight > 0) {
      cartListElem.style.maxHeight = `${cartListMaxHeight}px`;
    }
  };

  const onHeaderHeightChanged = function() {
    checkAndAssignHeaderElem();
    checkAndAssignMainContentElem();
    const currentHeaderHeight = theme?.RS?.helpers?.calculateTotalHeight(headerElem);
    const currentPaddingTop = mainContentElem?.style?.paddingTop;

    if (currentHeaderHeight !== headerHeight || currentPaddingTop !== `${currentHeaderHeight}px`) {
      if (currentHeaderHeight && mainContentElem) {
        mainContentElem.style.paddingTop = `${currentHeaderHeight}px`;
      }
    }
  };

  const dispatchTriggerCartHeightUpdate = function() {
    const event = new CustomEvent('triggerCartHeightUpdate', {
      detail: { message: 'Cart height update triggered' },
      bubbles: true,
      cancelable: true
    });
    
    document.dispatchEvent(event);
  };

  const registerAjaxCartObserver = function() {
    if (cartTriggerElem) {
      const targetNode = cartTriggerElem;
      const config = { attributes: true, attributeFilter: ['class'] };
  
      const callback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (targetNode.classList.contains(CART_VISIBLE_CLASS)) {
              dispatchTriggerCartHeightUpdate();
            }
          }
        }
      };
  
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
      return observer;
    }
  };

  const registerHeaderObserver = function() {
    const target = document.querySelector(selectors.header);
        
    if (target) {
      headerElem = target;
      // Callback function to execute when resize is observed
      const callback = function(entries, observer) {
        for(let entry of entries) {
          if (headerHeight !== entry.contentRect.height) {
            const event = new CustomEvent(
              HEADER_HEIGHT_EVENT,
              { detail: { height: headerHeight } }
            );
            document.dispatchEvent(event);
          }
        }
      };
  
      // Create an observer instance linked to the callback function
      const observer = new ResizeObserver(callback);
  
      // Start observing the target node for configured mutations
      observer.observe(target);
      return observer;
    }
  };

  const registerAjaxContentObserver = function() {
    if (cartDrawerElem) {
      const config = { childList: true };
      const callback = function(mutationsList, observer) {
        for(let mutation of mutationsList) {
          if (mutation.type === 'childList') {
            dispatchTriggerCartHeightUpdate();
          }
        }
      };
  
      const observer = new MutationObserver(callback);
      observer.observe(cartDrawerElem, config);
      return observer;
    }
  };

  const initHeaderOberserver = function() {
    headerObserver = registerHeaderObserver();
  };

  const initCartHeight = function() {
    checkAndAssignCartElements();

    document.addEventListener('triggerCartHeightUpdate', function(e) {
      setCartHeight();
    });

    // isHeaderCollapsed();
    ajaxCartObserver = registerAjaxCartObserver();
    ajaxContentObserver = registerAjaxContentObserver();
    setCartHeight();
  };

  const initMainContentPadding = function() {
    mainContentElem = document.querySelector(selectors.mainContent);
    onHeaderHeightChanged();
  };

  document.addEventListener('DOMContentLoaded', function() {
    initHeaderOberserver();
    initCartHeight();
    initMainContentPadding();
  });

  document.addEventListener(HEADER_HEIGHT_EVENT, function() {
    const currentHeaderHeight = theme?.RS?.helpers?.calculateTotalHeight(headerElem);
    if (headerHeight !== currentHeaderHeight) {
      dispatchTriggerCartHeightUpdate();
      headerHeight = currentHeaderHeight;
    }
    onHeaderHeightChanged();
  });

  // Update cart height on window height resize
  $(window).resize(
    $.debounce(200, function() {
      const currentHeight = window.innerHeight || document.documentElement.clientHeight;
      const currentWidth = window.innerWidth || document.documentElement.clientWidth;
      let hasChanged = false;

      if (windowHeight !== currentHeight) {
        windowHeight = currentHeight;
        hasChanged = true;
      }
      if (windowWidth !== currentWidth) {
        windowWidth = currentWidth;
        hasChanged = true;
      }
      if (hasChanged) {
        dispatchTriggerCartHeightUpdate();
        onHeaderHeightChanged();
      }
    })
  );

  // Disconnect observers when navigating away
  window.addEventListener('beforeunload', function() {
    ajaxCartObserver?.disconnect();
    headerObserver?.disconnect();
    ajaxContentObserver?.disconnect();
  });

  return {
    dispatchTriggerCartHeightUpdate
  }
})();